import React, { Component } from "react";
import { Modal } from "antd";
import DragM from "dragm";

export class TTPModal extends Component {
  render() {
    return (
      <Modal
        closable={false}
        maskClosable={true}
        destroyOnClose={true}
        visible={this.props.visible}
        onOk={this.props.handleOk}
        onCancel={this.props.handleCancel}
        width={this.props.width}
        footer={this.props.footer}
        mask={this.props.mask}
      >
        {this.props.children}
      </Modal>
    );
  }
}

export class DragModal extends React.Component {
  updateTransform = transformStr => {
    this.modalDom.style.transform = transformStr;
  };
  componentDidMount() {
    this.modalDom = document.getElementsByClassName("ant-modal-wrap")[0];
  }
  render() {
    return (
      <DragM updateTransform={this.updateTransform}>
        <div style={{ display: "inline-block" }}>{this.props.children}</div>
      </DragM>
    );
  }
}

export default TTPModal;



// WEBPACK FOOTER //
// ./src/components/Common/Modal/TTPModal.js